import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Box, Typography, Button, IconButton, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Logo from '../../assets/LogoTransfer.svg';
import Download from '../../assets/DownloadSimple.svg';

const labelSx = {
   color: '#58564d',
   fontSize: '0.95rem',
};

const valueBoxSx = {
   border: '1px solid #E3E3E3',
   borderRadius: '8px',
   padding: '14px 16px',
   minHeight: '58px',
   display: 'flex',
   flexDirection: 'column',
   alignItems: 'flex-start',
   justifyContent: 'flex-start',
   gap: '4px',
   color: '#2E2C21',
   fontWeight: 600,
};

const ActivityReceiptDialog = ({ open, onClose }) => {
   return (
      <Dialog
         open={open}
         onClose={onClose}
         fullWidth
         maxWidth="sm"
         sx={{
            '& .MuiDialog-paper': {
               maxWidth: { xs: 'calc(100% - 24px)', sm: 520 },
               width: { xs: 'calc(100% - 24px)', sm: 'auto' },
               m: { xs: 1.5, sm: 'auto' },
            },
         }}
      >
         <DialogTitle
            sx={{
               fontSize: '1.8rem',
               fontWeight: 600,
               color: '#2E2C21',
               borderBottom: '1px solid #E3E3E3',
            }}
         >
            <Box component="img" src={Logo} alt="Parrotica Logo" />
            
            <IconButton
               aria-label="close"
               onClick={onClose}
               sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
            >
               <CloseIcon />
            </IconButton>
            
            <Typography 
               className='font-cormorant' 
               sx={{ 
                  fontSize: { xs: '1.5rem', sm: '2rem' }, 
                  fontWeight: 600, 
                  color: '#2E2C21', 
                  textAlign: 'center', 
                  width: '100%',
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
               }}
            >
               Transfer SMS Units Receipt
            </Typography>
         </DialogTitle>

         <DialogContent>
            <Box id="activity-receipt-content" sx={{ mt: 2 }}>
               <Typography align="center" sx={{ color: '#58564d', mb: 1 }}>
                  Units Transferred
               </Typography>
               <Typography 
                  className='font-nunito' 
                  align="center" 
                  sx={{ fontSize: '1.5rem', color: '#2E2C21', fontWeight: 500, mb: 3 }}
               >
                  500 SMS
               </Typography>

               <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                     <Box sx={valueBoxSx}>
                        <Typography sx={labelSx}>Transaction ID</Typography>
                        <Typography sx={{ fontWeight: 600, color: '#2E2C21' }}>TXN123456789</Typography>
                     </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                     <Box sx={valueBoxSx}>
                        <Typography sx={labelSx}>Date & Time of Transaction</Typography>
                        <Typography sx={{ fontWeight: 600, color: '#2E2C21' }}>09 Oct 2025, 14:30</Typography>
                     </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                     <Box sx={valueBoxSx}>
                        <Typography sx={labelSx}>Transferred By</Typography>
                        <Typography sx={{ fontWeight: 600, color: '#2E2C21' }}>John Doe</Typography>
                     </Box>
                  </Grid>
                  <Grid item xs={12} md={6}>
                     <Box sx={valueBoxSx}>
                        <Typography sx={labelSx}>Transferred To</Typography>
                        <Typography sx={{ fontWeight: 600, color: '#2E2C21' }}>Jane Smith</Typography>
                     </Box>
                  </Grid>
               </Grid>
            </Box>
         </DialogContent>

         <DialogActions sx={{ p: 2 }}>
            <Button
               variant="contained"
               sx={{
                  background: '#0040BF',
                  textTransform: 'none',
                  fontWeight: 700,
                  borderRadius: '10px',
                  px: 3,
               }}
               endIcon={<img src={Download} alt="" style={{ width: 20, height: 20 }} />}
               fullWidth
            >
               Download Receipt
            </Button>
         </DialogActions>
      </Dialog>
   );
};

export default ActivityReceiptDialog;